import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { FabrikatDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fabrikat-dto';
import { ProduktDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/produkt-dto';
import { ProduktEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/produkt-enum';
import { ModelFilter } from 'src/app/components/aftale/models';

@Component({
  selector: 'app-model-list-filter',
  templateUrl: './model-list-filter.component.html',
  styleUrls: ['./model-list-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModelListFilterComponent implements OnInit, OnDestroy {
  isLoading: boolean = false;

  @Input() produkter: ProduktDto[];
  @Input() fabrikater: FabrikatDto[];
  @Input() filter: ModelFilter;

  unsubscribe$ = new Subject<void>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.changeFilterParams();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  filterCount() {
    return this.filter.productIds.length + this.filter.fabrikatIds.length;
  }

  hasFilters(): boolean {
    return this.filter.productIds.length > 0 || this.filter.fabrikatIds.length > 0;
  }

  onProductToggle(id: ProduktEnum) {
    this.toggleValue(this.filter.productIds, id);
  }

  toggleValue(array: any[], id: any) {
    if (array.indexOf(id) > -1) {
      array.splice(array.indexOf(id), 1);
    } else {
      array.push(id);
    }
    this.changeFilterParams();
  }

  isProductChecked(id: ProduktEnum) {
    return this.filter.productIds.indexOf(id) > -1;
  }

  changeFilterParams() {
    const uniqueProductIds = this.filter.productIds.filter((v, i, a) => a.indexOf(v) === i);
    const uniqueFabrikatIds = this.filter.fabrikatIds.filter((v, i, a) => a.indexOf(v) === i);

    const queryParams: Params = {
      productIds: this.filter.productIds.length > 0 ? uniqueProductIds : null,
      fabrikatIds: this.filter.fabrikatIds.length > 0 ? uniqueFabrikatIds : null,
    };

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
      preserveFragment: true,
    });
  }

  reset() {
    this.filter = {
      productIds: [],
      fabrikatIds: [],
    };
    this.changeFilterParams();
  }

  onFabrikatChange(fabrikatIds: number[]) {
    this.filter.fabrikatIds = fabrikatIds;
    this.changeFilterParams();
  }
}
